import React, { useEffect, useState, useRef } from 'react';
import './GameWrapper.css';
import GameView from '../pages/GameView';
import { updateCanvasVars } from '../utils/CanvasScaler';

function GameWrapper() {
  const [dimensions, setDimensions] = useState(null);
  const canvasRef = useRef();

  useEffect(() => {
    const updateSize = () => {
      const baseW = 1920;
      const baseH = 1080;
      const aspectRatio = baseW / baseH;

      const winW = window.innerWidth;
      const winH = window.innerHeight;
      const winRatio = winW / winH;

      let finalW, finalH;

      if (winRatio > aspectRatio) {
        finalH = winH;
        finalW = finalH * aspectRatio;
      } else {
        finalW = winW;
        finalH = finalW / aspectRatio;
      }

      setDimensions({ width: finalW, height: finalH });
    };

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    if (canvasRef.current && dimensions) {
      requestAnimationFrame(() => {
        updateCanvasVars(canvasRef.current);
      });
    }
  }, [dimensions]);

  const getTimeOfDay = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 9) return "morning";
    if (hour >= 9 && hour < 18) return "day";
    if (hour >= 18 && hour < 20) return "evening";
    return "night";
  };

  const [timeOfDay, setTimeOfDay] = useState(getTimeOfDay());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeOfDay(getTimeOfDay());
    }, 1000 * 60 * 5); // 5 dakikada bir güncelle

    return () => clearInterval(interval);
  }, []);

  if (!dimensions) return null;


  return (
    <div className={`game-wrapper ${timeOfDay}`}>
      <div
        ref={canvasRef}
        className="game-canvas"
        style={{
          width: `${dimensions.width}px`,
          height: `${dimensions.height}px`,
        }}
      >
        <GameView />
      </div>
    </div>
  );
}

export default GameWrapper;
